module.exports = __webpack_public_path__ + "static/media/lifeline_step_2.8bf907ba.png";